import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types';
import React, { MutableRefObject, useEffect, useRef, useState } from 'react';
import useMetaSearch from '../../../hooks/useMetaSearch';
import useBrowserMode from '../../../shared/hooks/useBrowserMode';
import { normalizeTwoWords } from '../../../shared/utils/stringUtilities';
import { changeRef, getTarget } from '../../../utils/location';
import './SearchBarHeader.scss';

interface SearcherInterface {
    compact?: boolean;
    type?: 'comfama' | 'preguntas';
    onSelect?: Function;
    scrollIntoQuestion?: Function;
    defaultPlaceholder?: string;
    placement?: string;
    setShowInfoModal?: Function;
}

const SearcherBarHeader = (props: SearcherInterface) => {
    const { compact, type, onSelect, scrollIntoQuestion, placement } = props;
    const node: MutableRefObject<any> = useRef();
    const [isActive, setActiveSelect] = useState(false);
    const [searchWord, setSearchWord] = useState('');

    const { filterSearch, doSearch } = useMetaSearch(type);
    const { isBrowser, window, document, localStorage }: any = useBrowserMode();

    const options = {
        renderNode: {
            [BLOCKS.PARAGRAPH]: (_node: any, children: any) => <>{children}</>,
        },
    };

    const handleClickOutside = (e: Event) => {
        if (node.current.contains(e.target)) {
            return null;
        } else {
            setActiveSelect(false);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && isBrowser && searchWord.trim().length > 3) {
            const redireccion = changeRef(
                `resultados-busqueda/?search=${searchWord}&sort=ASC`
            );
            window?.location.assign(redireccion);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isActive]);

    const renderFormattedText = (text, searchWords) => {
        const comparingText =
            text !== null &&
            text.toLowerCase().indexOf(searchWords.toLowerCase());

        return text !== null && comparingText !== -1 ? (
            <React.Fragment>
                {text.slice(0, comparingText)}
                <span>
                    {text.slice(
                        comparingText,
                        comparingText + searchWords.length
                    )}
                </span>
                {text.slice(comparingText + searchWords.length)}
            </React.Fragment>
        ) : (
            text
        );
    };

    const validateAfiliationModal = (name: string) => {
        const nameLowerCase = name.toLowerCase();
        if (nameLowerCase.includes('afi')) {
            return true;
        } else {
            return false;
        }
    };

    return (
        <>
            <div
                className={`m-searcherBar-container ${
                    compact ? 'm-searcherBar-container--compact' : ''
                } ${
                    type === 'preguntas'
                        ? 'm-searcherBar-container--compact-extended'
                        : ''
                } ${
                    placement === 'inside'
                        ? 'm-searcherBar-container--inside'
                        : ''
                }`}
            >
                <div
                    className={`m-searcherBar-container m-searcherBar-container__content ${
                        isActive || searchWord.trim().length > 3
                            ? 'm-searcherBar-container__content--active '
                            : ''
                    }
                    ${
                        placement === 'inside'
                            ? 'm-searcherBar-container__content--inside'
                            : ''
                    }
                    `}
                >
                    {/* aqui va el nuevo buscador */}
                    <div
                        className={
                            'm-searcherBar-container__input ' +
                            (placement === 'inside'
                                ? 'm-searcherBar-container__input--inside'
                                : '')
                        }
                    >
                        {/* {placement === "inside" && (
            <i
              className={"icon icon-search "}
              onClick={() =>
                isBrowser &&
                searchWord.trim().length > 3 &&
                window?.location.assign(
                  `/resultados-busqueda/?search=${searchWord}&sort=ASC`
                )
              }
            />
          )} */}
                        <input
                            // autoFocus
                            ref={node}
                            value={searchWord}
                            placeholder={'Buscar'}
                            onClickCapture={() => setActiveSelect(true)}
                            onChange={(text) => {
                                doSearch(text.currentTarget.value);
                                setSearchWord(text.currentTarget.value);
                            }}
                            onKeyDown={handleKeyDown}
                            // onBlur={() => {
                            //     if (placement === "inside") {
                            //         setSearchWord("");
                            //         doSearch("");
                            //     }
                            // }}
                        />
                        {placement === 'inside' ? (
                            <button
                                className={
                                    'm-searcherBar-container__input--inside__arrow'
                                }
                                onClick={
                                    () => {
                                        if (searchWord.trim().length > 3) {
                                            window.dataLayer =
                                                window.dataLayer || [];
                                            window.dataLayer.push({
                                                event: 'pushEventGA',
                                                category:
                                                    localStorage.getItem(
                                                        'CURRENT_TAB'
                                                    ) === 'personas'
                                                        ? 'HomePersonas'
                                                        : 'HomeEmpresas',
                                                action: 'ClicBuscadorHome',
                                                label: searchWord,
                                            });
                                            setSearchWord('');
                                            doSearch('');
                                        }
                                    }
                                    // window.location.assign(
                                    //     `/resultados-busqueda/?search=${searchWord}&sort=ASC`
                                    // )
                                }
                            >
                                <i
                                    className={
                                        'icon ' +
                                        (searchWord.trim().length > 3
                                            ? 'icon-close'
                                            : 'icon-search')
                                    }
                                />
                            </button>
                        ) : (
                            searchWord.trim().length > 3 && (
                                <i
                                    className="icon icon-times-circle1"
                                    onClickCapture={() => {
                                        setSearchWord('');
                                        doSearch('');
                                    }}
                                />
                            )
                        )}
                    </div>

                    {placement !== 'inside' &&
                        (searchWord.trim().length > 3 || !compact) && (
                            <div className="m-searcherBar-container__separator" />
                        )}
                    {(searchWord.trim().length > 3 || !compact) && (
                        <div
                            className={
                                'm-searcherBar-container__results ' +
                                (placement === 'inside' &&
                                searchWord.trim().length <= 3
                                    ? 'm-searcherBar-container__results--inside'
                                    : '')
                            }
                        >
                            <ul>
                                {compact &&
                                    type === 'preguntas' &&
                                    filterSearch &&
                                    filterSearch.length === 0 && (
                                        <li>
                                            <span className="m-searcherBar-results__title">
                                                {`No encontramos resultados para "${searchWord.trim()}"`}
                                            </span>
                                        </li>
                                    )}
                                {filterSearch &&
                                    filterSearch.map((result: any, index) => (
                                        <li
                                            key={`result${index}`}
                                            onClick={() => {
                                                if (
                                                    onSelect !== undefined &&
                                                    scrollIntoQuestion !==
                                                        undefined &&
                                                    !validateAfiliationModal(
                                                        result.titulo
                                                    )
                                                ) {
                                                    window.dataLayer =
                                                        window.dataLayer || [];
                                                    window.dataLayer.push({
                                                        event: 'pushEventGA',
                                                        category:
                                                            localStorage.getItem(
                                                                'CURRENT_TAB'
                                                            ) === 'personas'
                                                                ? 'HomePersonas'
                                                                : 'HomeEmpresas',
                                                        action: 'ClicBuscadorHome',
                                                        label: searchWord,
                                                    });

                                                    if (
                                                        validateAfiliationModal(
                                                            result.titulo
                                                        )
                                                    ) {
                                                        props.setShowInfoModal(
                                                            true
                                                        );
                                                    } else {
                                                        onSelect(result);
                                                        setSearchWord('');
                                                        doSearch('');
                                                        scrollIntoQuestion(
                                                            result.titulo
                                                        );
                                                    }
                                                }
                                            }}
                                        >
                                            {!validateAfiliationModal(
                                                result.titulo
                                            ) ? (
                                                <a
                                                    href={`${result.redireccion}`}
                                                    target={getTarget(
                                                        result?.redireccion ??
                                                            '/'
                                                    )}
                                                    rel="noopener noreferrer"
                                                    title={result.titulo}
                                                    onClick={() => {
                                                        window.dataLayer =
                                                            window.dataLayer ||
                                                            [];
                                                        window.dataLayer.push({
                                                            event: 'pushEventGA',
                                                            category:
                                                                localStorage.getItem(
                                                                    'CURRENT_TAB'
                                                                ) === 'personas'
                                                                    ? 'HomePersonas'
                                                                    : 'HomeEmpresas',
                                                            action: 'ClicBuscadorHome',
                                                            label: searchWord,
                                                        });

                                                        if (
                                                            validateAfiliationModal(
                                                                result.titulo
                                                            )
                                                        ) {
                                                            props.setShowInfoModal(
                                                                true
                                                            );
                                                        }
                                                    }}
                                                    className={`gtmResultadosPredictivo${normalizeTwoWords(
                                                        type === 'comfama'
                                                            ? result.titulo
                                                            : result.tituloBanner
                                                    )}${normalizeTwoWords(
                                                        result.tipoContenido
                                                    )}${normalizeTwoWords(
                                                        result.categoria
                                                    )}`}
                                                >
                                                    <p
                                                        className={`gtmResultadosPredictivo${normalizeTwoWords(
                                                            type === 'comfama'
                                                                ? result.titulo
                                                                : result.tituloBanner
                                                        )}${normalizeTwoWords(
                                                            result.tipoContenido
                                                        )}${normalizeTwoWords(
                                                            result.categoria
                                                        )}`}
                                                    >
                                                        <span
                                                            className={`m-searcherBar-results__title 
                                       gtmResultadosPredictivo${normalizeTwoWords(
                                           type === 'comfama'
                                               ? result.titulo
                                               : result.tituloBanner
                                       )}${normalizeTwoWords(
                                           result.tipoContenido
                                       )}${normalizeTwoWords(
                                           result.categoria
                                       )}`}
                                                        >
                                                            {renderFormattedText(
                                                                type ===
                                                                    'comfama'
                                                                    ? result.titulo
                                                                    : result.tituloBanner,
                                                                searchWord
                                                            )}
                                                        </span>
                                                        <br />
                                                        {result.descripcion && (
                                                            <span
                                                                className={`m-searcherBar-results__subtitle
                                       gtmResultadosPredictivo${normalizeTwoWords(
                                           type === 'comfama'
                                               ? result.titulo
                                               : result.tituloBanner
                                       )}${normalizeTwoWords(
                                           result.tipoContenido
                                       )}${normalizeTwoWords(result.categoria)}
                                 `}
                                                            >
                                                                {result.descripcion &&
                                                                    documentToReactComponents(
                                                                        result
                                                                            .descripcion
                                                                            .json,
                                                                        options
                                                                    )}
                                                            </span>
                                                        )}
                                                    </p>
                                                </a>
                                            ) : (
                                                <p
                                                    className={`gtmResultadosPredictivo${normalizeTwoWords(
                                                        type === 'comfama'
                                                            ? result.titulo
                                                            : result.tituloBanner
                                                    )}${normalizeTwoWords(
                                                        result.tipoContenido
                                                    )}${normalizeTwoWords(
                                                        result.categoria
                                                    )}`}
                                                    onClick={() =>
                                                        props.setShowInfoModal(
                                                            true
                                                        )
                                                    }
                                                >
                                                    <span
                                                        className={`m-searcherBar-results__title 
                                     gtmResultadosPredictivo${normalizeTwoWords(
                                         type === 'comfama'
                                             ? result.titulo
                                             : result.tituloBanner
                                     )}${normalizeTwoWords(
                                         result.tipoContenido
                                     )}${normalizeTwoWords(result.categoria)}`}
                                                    >
                                                        {renderFormattedText(
                                                            type === 'comfama'
                                                                ? result.titulo
                                                                : result.tituloBanner,
                                                            searchWord
                                                        )}
                                                    </span>
                                                    <br />
                                                    {result.descripcion && (
                                                        <span
                                                            className={`m-searcherBar-results__subtitle
                                     gtmResultadosPredictivo${normalizeTwoWords(
                                         type === 'comfama'
                                             ? result.titulo
                                             : result.tituloBanner
                                     )}${normalizeTwoWords(
                                         result.tipoContenido
                                     )}${normalizeTwoWords(result.categoria)}
                               `}
                                                        >
                                                            {result.descripcion &&
                                                                documentToReactComponents(
                                                                    result
                                                                        .descripcion
                                                                        .json,
                                                                    options
                                                                )}
                                                        </span>
                                                    )}
                                                </p>
                                            )}
                                        </li>
                                    ))}
                            </ul>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default SearcherBarHeader;
